import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-publicite',
  templateUrl: './publicite.component.html',
  styleUrls: ['./publicite.component.scss']
})
export class PubliciteComponent implements OnInit {

  currentYear = new Date().getFullYear();

  
  // Hero Section
  pageTitle = "Publicité en Ligne en France";
  pageSubtitle = "Boostez votre visibilité et générez plus de clients avec nos campagnes publicitaires ciblées";
  
  // Stats
  stats = [
    { number: '+350%', label: 'ROI Moyen' },
    { number: '24h', label: 'Activation Campagne' },
    { number: '98%', label: 'Satisfaction Client' },
    { number: '500+', label: 'Campagnes Réussies' }
  ];
  
  // Services Features
  services = [
    {
      icon: '🎯',
      title: 'Google Ads',
      description: 'Campagnes Search, Display, Shopping et YouTube optimisées pour maximiser votre ROI',
      features: [
        'Recherche de mots-clés stratégiques',
        'Création d\'annonces performantes',
        'Optimisation des enchères',
        'Rapports détaillés mensuels'
      ]
    },
    {
      icon: '📱',
      title: 'Meta Ads (Facebook & Instagram)',
      description: 'Publicités social media ciblées pour engager votre audience et générer des conversions',
      features: [
        'Ciblage précis par audience',
        'Création de visuels impactants',
        'A/B testing systématique',
        'Retargeting avancé'
      ]
    },
    {
      icon: '💼',
      title: 'LinkedIn Ads',
      description: 'Atteignez les décideurs B2B avec des campagnes LinkedIn hautement ciblées',
      features: [
        'Ciblage professionnel avancé',
        'Lead generation forms',
        'Sponsored content',
        'InMail sponsorisés'
      ]
    },
    {
      icon: '🎬',
      title: 'Publicité Vidéo',
      description: 'Campagnes vidéo sur YouTube, TikTok et autres plateformes pour maximiser l\'engagement',
      features: [
        'Création de vidéos publicitaires',
        'Campagnes multi-plateformes',
        'Optimisation du taux de vue',
        'Analytics vidéo détaillés'
      ]
    }
  ];
  
  // Process Steps
  processSteps = [
    {
      step: '01',
      title: 'Audit & Stratégie',
      description: 'Analyse de votre marché, concurrence et définition des objectifs publicitaires'
    },
    {
      step: '02',
      title: 'Setup Campagne',
      description: 'Configuration des comptes, création des campagnes et définition du ciblage'
    },
    {
      step: '03',
      title: 'Création Contenus',
      description: 'Design des visuels, rédaction des copies et production des créatifs'
    },
    {
      step: '04',
      title: 'Lancement & Optimisation',
      description: 'Activation des campagnes et optimisation continue pour maximiser les résultats'
    }
  ];
  
  // Pricing Packages (EUR)
  packages = [
    {
      name: 'Starter',
      price: '590',
      period: '€/mois',
      description: 'Idéal pour débuter avec la publicité en ligne',
      features: [
        '1 plateforme au choix',
        'Budget publicitaire: jusqu\'à 1 200€',
        'Création de 3 annonces',
        'Rapport mensuel',
        'Support email'
      ],
      popular: false
    },
    {
      name: 'Business',
      price: '990',
      period: '€/mois',
      description: 'Pour les entreprises en croissance',
      features: [
        '2 plateformes publicitaires',
        'Budget publicitaire: jusqu\'à 3 000€',
        'Création de 10 annonces',
        'Rapports bi-mensuels',
        'Support prioritaire',
        'A/B Testing',
        'Retargeting inclus'
      ],
      popular: true
    },
    {
      name: 'Premium',
      price: 'Sur devis',
      period: '',
      description: 'Solution complète pour grandes entreprises',
      features: [
        'Multi-plateformes illimitées',
        'Budget publicitaire illimité',
        'Création illimitée d\'annonces',
        'Rapports hebdomadaires',
        'Account manager dédié',
        'Stratégie complète',
        'Optimisation avancée',
        'Workshops mensuels'
      ],
      popular: false
    }
  ];
  
  // FAQ
  faqs = [
    {
      id: 1,
      question: 'Quel budget publicitaire dois-je prévoir ?',
      answer: 'Le budget dépend de vos objectifs et de votre secteur. Nous recommandons généralement un minimum de 500€/mois pour obtenir des résultats significatifs. Nous vous conseillerons sur le budget optimal lors de notre audit initial.',
      active: false
    },
    {
      id: 2,
      question: 'Combien de temps avant de voir des résultats ?',
      answer: 'Vous verrez les premières données dès le lancement (24-48h). Les premiers leads/ventes arrivent généralement dans la première semaine. L\'optimisation continue améliore les résultats sur 2-3 mois.',
      active: false
    },
    {
      id: 3,
      question: 'Quelle plateforme publicitaire choisir ?',
      answer: 'Cela dépend de votre audience cible et objectifs. Google Ads est idéal pour l\'intention d\'achat, Meta Ads pour l\'engagement et la notoriété, LinkedIn pour le B2B. Nous vous recommanderons la meilleure stratégie lors de l\'audit.',
      active: false
    },
    {
      id: 4,
      question: 'Puis-je gérer moi-même mes campagnes après ?',
      answer: 'Oui, nous pouvons vous former à la gestion de vos campagnes. Cependant, l\'expertise continue de nos spécialistes garantit une optimisation constante et de meilleurs résultats.',
      active: false
    },
    {
      id: 5,
      question: 'Travaillez-vous avec des entreprises de toutes tailles ?',
      answer: 'Absolument ! Nous accompagnons aussi bien les TPE/PME que les grandes entreprises françaises. Nos forfaits sont adaptés à chaque niveau de maturité digitale.',
      active: false
    }
  ];
  
  // Testimonials
 // Testimonials - UPDATED WITH INDIVIDUAL IMAGES
testimonials = [
  {
    name: 'Pierre Dubois',
    company: 'TechStart Paris',
    text: 'Nos conversions ont augmenté de 400% en 3 mois grâce à Digital Alchemy. Le ROI est exceptionnel!',
    rating: 5,
    image: 'assets/images/m2.jpeg'  // ← Pierre's photo
  },
  {
    name: 'Marie Laurent',
    company: 'Fashion Boutique Lyon',
    text: 'L\'équipe est professionnelle et très réactive. Nos ventes en ligne ont explosé depuis le début des campagnes Meta Ads.',
    rating: 5,
    image: 'assets/images/w2.webp'  // ← Marie's photo
  }
];

  // Contact Info
  contactInfo = {
    phone: '+33 1 23 45 67 89',
    email: 'contact@digitalalchemy.fr'
  };

  constructor() { }

  ngOnInit(): void {
  }
  
  // FAQ Methods
  toggleFaq(faqId: number): void {
    this.faqs.forEach(faq => {
      if (faq.id === faqId) {
        faq.active = !faq.active;
      } else {
        faq.active = false;
      }
    });
  }
  
  // Scroll to section
  scrollToSection(sectionId: string): void {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }
}